/**
 * 客户回款，银行登记单 详情页面配置
 * @author zjs
 * @time 2017-10-26
 */
export default {
    data () {
        return {
            customerConfig: {
                config: {
                    isNumber: true
                },
                head: [
                    {
                        "prop": "transaction_no_display",
                        "label": "单号"
                    }, {
                        "prop": "work_time",
                        "label": "单据日期"
                    }, {
                        "prop": "customer_account",
                        "label": "客户编码"
                    }, {
                        "prop": "customer_name",
                        "label": "客户名称"
                    }, {
                        "prop": "product_name",
                        "label": "往来项目"
                    }, {
                        "prop": "brand_name",
                        "label": "品牌"
                    }, {
                        "prop": "amount",
                        "label": "金额"
                    }, {
                        "prop": "weidu_name",
                        "label": "核算维度"
                    }, {
                        "prop": "employee_name",
                        "label": "单据业务员"
                    }, {
                        "prop": "zhaiyao",
                        "label": "备注"
                    }
                ]
            }// 客户列表的配置
        }
    }
}